import { Link } from '@trussworks/react-uswds';
import { mdiOpenInNew } from '@mdi/js';

import Icon from '@src/app-components/icon/Icon';

import './publicNoticeLink.scss';

const PublicNoticeLink = ({ children, content, href, title }) => {
  const displayName = href?.replace(/(^\w+:|^)\/\//, '');
  const extensionIcon = mdiOpenInNew;

  return (
    <div className='public-notice-link'>
      <Icon focusable={false} path={extensionIcon} size={1} />
      <Link href={href} rel='noreferrer' tabIndex={0} target='_blank' title={title ?? undefined}>
        {displayName ?? content ?? children ?? href}
      </Link>
    </div>
  );
};

export default PublicNoticeLink;
